export default __webpack_public_path__ + "static/media/laravel.6a015ee5.svg";